import { useMemo } from "react";
import L from "leaflet";
import { Marker, Popup } from "react-leaflet";
import { POLLEN_LINKS, POLLEN_SITES, inPollenSeason } from "./pollen";

// A diamond rather than a dot, so pollen sites never read as air quality
// stations
const icon = (inSeason) =>
  L.divIcon({
    className: "aq-pollen-anchor",
    html: `<span class="aq-pollen${inSeason ? "" : " aq-pollen--off"}"></span>`,
    iconSize: [22, 22],
    iconAnchor: [11, 11],
    popupAnchor: [0, -12],
  });

export const PollenSites = () => {
  const inSeason = inPollenSeason();
  const markerIcon = useMemo(() => icon(inSeason), [inSeason]);

  return POLLEN_SITES.map((site) => (
    <Marker
      key={site.id}
      position={[site.lat, site.lon]}
      icon={markerIcon}
      title={`Pollen monitor, ${site.name}`}
    >
      <Popup pane="popupPane" closeButton={false} minWidth={240}>
        <div className="aq-popup">
          <p className="aq-popup__level">
            <span className="aq-pollen aq-pollen--small" aria-hidden="true" />
            Pollen monitor
          </p>
          <h3 className="aq-popup__name">{site.name}</h3>
          <p className="aq-popup__wind">
            {site.place}. Automatic counts since {site.since}, updated hourly
            from April to September.{" "}
            {inSeason
              ? "Counts aren't published as a data feed yet, so they can't be shown here."
              : "Out of season now; measurements resume in April."}
          </p>
          <p className="aq-popup__links">
            <a href={POLLEN_LINKS.live} target="_blank" rel="noreferrer">
              Live counts
            </a>
            <a href={POLLEN_LINKS.forecast} target="_blank" rel="noreferrer">
              Pollen forecast
            </a>
          </p>
        </div>
      </Popup>
    </Marker>
  ));
};
